<section name="header">
  <aig-header id="header"></aig-header>
</section>
<router-outlet></router-outlet>
<section>
  <aig-footer></aig-footer>
</section>